/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespLayout_viewer = {
    readonly user?: {
        readonly " $fragmentRefs": FragmentRefs<"PdpRespContainer_user" | "PdpSharedLayout_user">;
    } | null;
    readonly itemRead: ReadonlyArray<{
        readonly displayInfo?: {
            readonly " $fragmentRefs": FragmentRefs<"PdpRespContainer_displayInfo">;
        } | null;
        readonly " $fragmentRefs": FragmentRefs<"PdpRespContainer_item">;
    } | null> | null;
    readonly similarLandingItems?: {
        readonly " $fragmentRefs": FragmentRefs<"PdpRespContainer_similarLandingItems">;
    } | null;
    readonly relevantShipping: {
        readonly shipmentQuote: {
            readonly " $fragmentRefs": FragmentRefs<"PdpRespContainer_shipmentQuote">;
        } | null;
        readonly shipment: {
            readonly " $fragmentRefs": FragmentRefs<"PdpRespContainer_shipment">;
        } | null;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespContainer_viewer" | "PdpSharedLayout_viewer">;
    readonly " $refType": "PdpRespLayout_viewer";
};
export type PdpRespLayout_viewer$data = PdpRespLayout_viewer;
export type PdpRespLayout_viewer$key = {
    readonly " $data"?: PdpRespLayout_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespLayout_viewer">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "buyerId",
  "variableName": "userId"
},
v1 = {
  "kind": "Variable",
  "name": "itemId",
  "variableName": "itemId"
};
return {
  "kind": "Fragment",
  "name": "PdpRespLayout_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userId",
      "type": "String!"
    },
    {
      "kind": "RootArgument",
      "name": "fetchUser",
      "type": "Boolean"
    },
    {
      "kind": "RootArgument",
      "name": "itemIds",
      "type": "[String]!"
    },
    {
      "kind": "RootArgument",
      "name": "isClient",
      "type": "Boolean"
    },
    {
      "kind": "RootArgument",
      "name": "fetchPdp",
      "type": "Boolean"
    },
    {
      "kind": "RootArgument",
      "name": "itemId",
      "type": "String!"
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "itemRead",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "itemIds",
          "variableName": "itemIds"
        }
      ],
      "concreteType": null,
      "plural": true,
      "selections": [
        {
          "kind": "InlineFragment",
          "type": "Item",
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "PdpRespContainer_item",
              "args": null
            },
            {
              "kind": "Condition",
              "passingValue": true,
              "condition": "isClient",
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "displayInfo",
                  "storageKey": null,
                  "args": [
                    (v0/*: any*/),
                    {
                      "kind": "Literal",
                      "name": "page",
                      "value": "pdp"
                    }
                  ],
                  "concreteType": "ItemDisplayInfo",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "FragmentSpread",
                      "name": "PdpRespContainer_displayInfo",
                      "args": null
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "relevantShipping",
      "storageKey": null,
      "args": [
        (v0/*: any*/),
        (v1/*: any*/)
      ],
      "concreteType": "RelevantShippingInfo",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "shipmentQuote",
          "storageKey": null,
          "args": null,
          "concreteType": "ShipmentQuote",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "PdpRespContainer_shipmentQuote",
              "args": null
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "shipment",
          "storageKey": null,
          "args": null,
          "concreteType": "Shipment",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "PdpRespContainer_shipment",
              "args": null
            }
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespContainer_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedLayout_viewer",
      "args": null
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "fetchUser",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "user",
          "storageKey": null,
          "args": [
            {
              "kind": "Variable",
              "name": "userId",
              "variableName": "userId"
            }
          ],
          "concreteType": "User",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "PdpRespContainer_user",
              "args": null
            },
            {
              "kind": "FragmentSpread",
              "name": "PdpSharedLayout_user",
              "args": null
            }
          ]
        }
      ]
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "fetchPdp",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": "similarLandingItems",
          "name": "moreLikeThisItem",
          "storageKey": null,
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 12
            },
            (v1/*: any*/)
          ],
          "concreteType": "moreLikeThisItemConnection",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "PdpRespContainer_similarLandingItems",
              "args": null
            }
          ]
        }
      ]
    }
  ]
};
})();
(node as any).hash = 'dc46c0771f747bb6785e83db6c3d0a78';
export default node;
